<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="`Delete Category -- ${categoryName}`"
    :reset-modal="resetModal"
    :submit-button-text="'DELETE'"
    :submit-modal="deleteCategory"
  >
    <div v-if="category">
      <b-row>
        <b-col>
          <p class="tsny_text">
            This action will delete the category "{{ categoryName }}" and all
            its associated sub-categories. Please be absolutely certain you want
            to do this -- this action cannot be undone.
          </p></b-col
        >
      </b-row>
      <b-row>
        <b-col
          ><p class="tsny_status-text" v-if="deleteCategoryError">
            An error occurred deleting {{ categoryName }}
          </p></b-col
        >
      </b-row>
    </div>
  </tsny-modal>
</template>

<script>
import TsnyModal from "../../TsnyModal";
import CourseRestService from "../../../services/rest/services/CourseRestService";

export default {
  name: "DeleteQuestionCategoryModal",
  components: { TsnyModal },
  props: {
    courseId: {
      type: String,
      default: null
    },
    category: {
      type: Object,
      default: null
    }
  },
  computed: {
    categoryName() {
      return this.category ? this.category.name : "Category Name";
    }
  },
  data: function() {
    return {
      modalId: "deleteCategoryModal",
      deleteCategoryError: null
    };
  },
  methods: {
    resetModal() {
      this.deleteCategoryError = null;
    },
    async deleteCategory(bvModalEvt) {
      bvModalEvt.preventDefault();

      let $comp = this;
      $comp.deleteCategoryError = false;

      try {
        await CourseRestService.deleteCategory($comp.courseId, $comp.category);
        $comp.$bvModal.hide($comp.modalId);
        $comp.$emit("category-deleted");
      } catch (err) {
        console.log(err);
        $comp.deleteCategoryError = true;
      }
    }
  }
};
</script>

<style scoped></style>
